import urljoin from 'url-join';
/** @internal */
export class AuthProxyUrlBuilder {
    // please note: registeredFags not supported in oneaudi implementation
    static getLoginUrl(authServiceOptions, registeredFags, locale, prompt, redirectUrl, loginOptions) {
        if (prompt) {
            // `prompt` parameter currently not supported by mod_auth_openidc (the token proxy) to
            // force the user to see the login-page again. If you have a valid token-proxy session, the token proxy
            // will always send you back directly to your target page without triggering an auth flow. This
            // local logout of apache session is discussed here:
            // https://groups.google.com/forum/#!searchin/mod_auth_openidc/local$20session%7Csort:date/mod_auth_openidc/YcwYU-DPyAo/TlRLWUDCAwAJ
            // but there is no progress on this topic. Because we currently don't know any use-case for this for
            // oneaudi we will not respect the prompt parameter here and write a console warn message.
            // eslint-disable-next-line no-console
            console.warn('prompt currently not supported');
        }
        const scopes = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const fag of registeredFags) {
            const fagScopes = authServiceOptions.fagScopeMappings.get(fag);
            if (fagScopes) {
                scopes.push(...fagScopes);
            }
        }
        const idsso = loginOptions && loginOptions.idsso;
        const loginUrl = [
            authServiceOptions.authProxyUrl,
            idsso ? '/login' : '/login/idk',
            `?target=${encodeURIComponent(redirectUrl || authServiceOptions.defaultLoginRedirectUrl)}`,
        ];
        if (!idsso) {
            loginUrl.push(`&ui_locales=${locale}`);
        }
        if (scopes.length > 0) {
            loginUrl.push(`&scopes=${encodeURIComponent(scopes.join(' '))}`);
        }
        return urljoin(loginUrl);
    }
    static getInfoHookUrl(authServiceOptions) {
        return urljoin(authServiceOptions.authProxyUrl, '/info');
    }
    static getLogoutUrl(authServiceOptions, defaultOrigin, csrfToken, redirectUrl) {
        // TODO-MYA: respect csrf token
        const logoutUrl = [authServiceOptions.authProxyUrl, '/logout'];
        if (redirectUrl) {
            const completeRedirectUrl = new URL(redirectUrl, defaultOrigin).toString();
            logoutUrl.push(`?redirect=${encodeURIComponent(completeRedirectUrl)}`);
        }
        return urljoin(logoutUrl);
    }
    static getProxyUrl(authServiceOptions, resourceHostId, path) {
        const proxyUrlParts = [authServiceOptions.authProxyUrl];
        if (resourceHostId) {
            proxyUrlParts.push(resourceHostId);
        }
        if (path) {
            proxyUrlParts.push(path);
        }
        return urljoin(proxyUrlParts);
    }
}
//# sourceMappingURL=AuthProxyUrlBuilder.js.map